<div *ngIf="avatarData" class="d-flex align-items-center">
  <app-avatar #avatar avatarSize="small" [avatarData]="avatarData"></app-avatar>
  <span class="ms-2">
    {{ avatarData.firstName }} {{ avatarData.lastName }}
  </span>
</div>
